module.exports = __webpack_public_path__ + "f4b181a740eeb106e694b6ed27d9eed0.png";